import { forwardRef } from "react";
import styles from "../desktop/DatePicker.desktop.module.css";
import type DatePickerType from "../DatePicker.type.ts";
import { useTranslation } from "react-i18next";

export const DateButtonInput = forwardRef<HTMLButtonElement, DatePickerType>(
  ({ value, onClick }, ref) => {
    const { t } = useTranslation();

    return (
      <button
        type="button"
        onClick={onClick}
        ref={ref}
        className={styles.button}
      >
        {value || t("ui.selectDate")}
      </button>
    );
  },
);
